<template>
  <div class="fmhind-select">
    <select class="fmhind-select__box" @change="onChange">
      <option
        v-for="option in options"
        :selected="option === value"
        :key="option"
        :value="option"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    options: {
      options: {
        type: Array,
        required: true
      }
    },
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedIndex: 0
    };
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.value);
    }
  }
};
</script>

<style lang="scss">
.fmhind-select {
  display: inline-block;
  position: relative;
  background: transparent;
  &:after {
    content: '';
    visibility: visible;
    display: block;
    position: absolute;
    width: $unit / 1.5;
    height: $unit / 1.5;
    border-right: 1px solid $color-primary;
    border-bottom: 1px solid $color-primary;
    top: $unit / 1.5;
    right: $unit;
    transform: rotate(45deg);
    z-index: -1;
  }
}
.fmhind-select__box {
  padding: $padding-md $unit * 3 $padding-md $padding-md;
  border: 1px solid $color-primary;
  appearance: none;
  position: relative;
  border-radius: 3px;
}
</style>
